$(() => {
  $(window).on("load", function () {
    const $oneTrustAdminPanelTrigger = $(".ot-sdk-show-settings");

    $oneTrustAdminPanelTrigger.on("click", function (e) {
      e.preventDefault();
    });
  });
});
